import { Component, OnInit, ViewChild, Inject, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DevolucionMercaderiaModalDevolverDocumentoComponent } from './modal-devolver-documento/modal-devolver-documento.component';
import { DevolucionMercaderiaModalDevolverProductoComponent } from './modal-devolver-producto/modal-devolver-producto.component';
import { DevolucionMercaderiaModalSeleccionarRecorridoComponent } from './modal-seleccionar-recorrido/modal-seleccionar-recorrido.component';
import { debounceTime, filter } from 'rxjs/operators';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { RecorridoDetalleService } from 'src/app/services/recorrido-detalle.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { MotivoDevolucionService } from 'src/app/services/motivo-devolucion.service';
import { Subscription } from 'apollo-client/util/Observable';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";
import * as _ from 'lodash';
@Component({
  selector: 'app-devolucion-mercaderia',
  templateUrl: './devolucion-mercaderia.component.html',
  styleUrls: ['./devolucion-mercaderia.component.scss'],
  providers: [SecurityService]
})
export class DevolucionMercaderiaComponent implements OnInit {

  // Modales
  @ViewChild(DevolucionMercaderiaModalDevolverDocumentoComponent, { static: true }) modalDevolverDocumento: DevolucionMercaderiaModalDevolverDocumentoComponent
  @ViewChild(DevolucionMercaderiaModalDevolverProductoComponent, { static: true }) modalDevolverProducto: DevolucionMercaderiaModalDevolverProductoComponent
  @ViewChild(DevolucionMercaderiaModalSeleccionarRecorridoComponent, { static: true }) modalSeleccionarRecorrido: DevolucionMercaderiaModalSeleccionarRecorridoComponent

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  loading: boolean = false
  listaRecorridos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  busquedaIniciada: boolean = false
  recorridoSeleccionado: any = null
  listaTiposDte: Array<any> = null
  areSelected: boolean = false
  optionsMotivoGeneral: Array<any> = [];
  permiteDocAnulacion: boolean = false
  permiteProducAnulacion: boolean = false

  //TODO: VARIABLES PARA SCROLL
  currentPayLoad: any;
  totalRegistrosPos: any;
  totalPagPos: any;
  PagPosActual: any;
  notEmptyPost = true;
  notscrolly = true;
  subscription: Subscription;
  private scrollHeight = 100;
  private PageNum = 1;
  showButton = false;
  showButtonDown: boolean;

  // Utils
  private log: any

  //TODO: PINTAR FILA
  HighlightRow: number;
  SelectRecorrido: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private spinner: NgxSpinnerService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private recorridoDetalleService: RecorridoDetalleService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private tipoDTEService: TipoDTEService,
    private motivoDevolucionService: MotivoDevolucionService
  ) {
    this.log = this.clog.log('DEVOLUCION-MERCADERIA')
    this.onScrollTop();
  }

  @HostListener('window:scroll')
  onWindowsScroll(): void {
    const yOffSet = window.pageYOffset;
    const scrollTop = this.document.documentElement.scrollTop;

    //* MOSTRAR U OCULTAR BOTONES DE AYUDA SCROLL
    if (this.listaRecorridos != null) {
      this.showButton = (yOffSet || scrollTop) > this.scrollHeight;
      this.showButtonDown = (yOffSet || scrollTop) >= 0
    }

  }

  //* LA BARRA DEL SCROLL QUEDA AL INICIO AL INGRESAR A LA VISTA - SCROLL CON BOTON SUBIR
  onScrollTop(): void {
    this.document.documentElement.scrollTop = 0;
  }

  //* SE PUEDE REALIZAR UN SCROLL A TRAVES DEL BOTON BAJAR
  onScrollAbajo(): void {
    this.document.documentElement.scrollBy(0, 1000)

  }

  //* AL REALIZAR EL SCROLL HACIA ABAJO SE AGREGAN LOS SIGUIENTES 100 DATOS DE LA PAGINA SGTE
  onScrollDown(e): void {
    console.log(e);
    const inputParams = _.cloneDeep(this.currentPayLoad);
    console.log(inputParams);
    if (inputParams != undefined || inputParams != null) {
      console.log("entro aqui");
      delete inputParams.paginaActual
      this.PageNum += 1
      inputParams.paginaActual = this.PageNum;

      this.spinner.show();
      if (this.notscrolly && this.notEmptyPost) {
        console.log("entra aqui", this.notscrolly, this.notEmptyPost);
        self.document.getElementById("spinnerX").style.display = "block";

        this.recorridoDetalleService.getDevolucionFiltro(inputParams);

        this.recorridoDetalleService.queryCliente.subscribe((data: any[]) => {
          console.log(data[0].obtenerDetalleRecorrido.respuesta);
          this.PagPosActual = data[0].obtenerDetalleRecorrido.respuesta.paginaActual
          this.totalPagPos = data[0].obtenerDetalleRecorrido.respuesta.totalPaginas
          this.totalRegistrosPos = data[0].obtenerDetalleRecorrido.respuesta.totalRegistros
          this.listaRecorridos.push(...data[0].obtenerDetalleRecorrido.respuesta.registros);
          // console.log("Dame los siguientes datos del paginado",this.listOfCliente)
          this.spinner.hide()
          self.document.getElementById("spinnerX").style.display = "block";
          if (data[0].obtenerDetalleRecorrido.respuesta.paginaActual === data[0].obtenerDetalleRecorrido.respuesta.totalPaginas) {
            this.notEmptyPost = false;
            self.document.getElementById("spinnerX").style.display = "none";
          }
          if (data[0].obtenerDetalleRecorrido.respuesta.registros.length < data[0].obtenerDetalleRecorrido.respuesta.cantidadRegistrosPorPagina) {
            self.document.getElementById("spinnerX").style.display = "none";
            this.PagPosActual = 1
          }
          this.notscrolly = true;

        })
      }
    }
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 20

    this.onScrollTop();

    this.loadTiposDte()
    this.createForm()
    this.formChangesSubscriptions()

    this.loadMotivoDevolucionGeneral()
  }

  loadTiposDte() {
    this.tipoDTEService.GetTiposDocumento(({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.listaTiposDte = registros
    })
  }

  ClickedRow(index, detalleRecorrido) {
    this.HighlightRow = index;
    this.SelectRecorrido = detalleRecorrido;

  }

  private createForm() {
    const fecha = this.datesService.CurrentDateToShortTimeString()
    this.formHeader = this.fb.group({
      nroRecorrido: [null, [Validators.required]],
      fechaDesde: [fecha, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("nroRecorrido").valueChanges
      .pipe(filter(Boolean), debounceTime(750))
      .subscribe((nroRecorrido: string) => {
        this.modalSeleccionarRecorrido.searchByCodigo(Number(nroRecorrido))
      })
  }

  private loadMotivoDevolucionGeneral() {
    // Tipos documentos
    this.motivoDevolucionService.GetMotivoDevolucionGeneral(this.rutEmpresa, this.sucursalCodigo, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsMotivoGeneral = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
    })
  }

  showModalDevolverDocumento(documento, fechaEmision) {
    this.modalDevolverDocumento.show(documento, fechaEmision)
  }

  showModalDevolverProducto(documento, fechaEmision) {
    this.modalDevolverProducto.show(this.recorridoSeleccionado, documento, fechaEmision)
  }

  showModalSeleccionarRecorrido() {
    this.modalSeleccionarRecorrido.show()
  }


  onRecorridoSeleccionado(recorrido) {
    this.log('Seleccionó', recorrido)
    this.recorridoSeleccionado = recorrido
    this.formHeader.get('nroRecorrido').setValue(recorrido.codigo)
    this.listaRecorridos = null
    // this.modalSeleccionarRecorrido.clearLast()
  }

  onNotFoundRecorrido() {
    this.clearRecorridoData()
  }

  clearRecorridoData() {
    this.recorridoSeleccionado = null
    this.listaRecorridos = null
  }

  iniciarDevolucion(pageNumber: number) {
    this.busquedaIniciada = true
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaRecorridos = []

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      codigoRecorrido: this.recorridoSeleccionado.codigo,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: 20
    }
    this.currentPayLoad = _.cloneDeep(inputParams);

    this.log('inputParams', JSON.stringify(inputParams))

    // this.loading = true

    // this.recorridoDetalleService.obtenerDetalleRecorrido(inputParams, ({ mensajes, respuesta }) => {
    //   const ok = respuesta !== null
    //   if (!ok) {
    //     this.messageRendererService.showErrors(mensajes)
    //     return
    //   }
    //   const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
    //   this.paginationContext.RecordsCount = totalRegistros
    //   this.paginationContext.CurrentPage = paginaActual
    //   this.paginationContext.PagesCount = totalPaginas
    //   this.listaRecorridos = registros
    //   console.log("ASFASFAS ",registros)

    //   this.listaRecorridos.map(recorrido => {
    //     recorrido.rutEmisorFormato = this.rutService.AgregarDV(recorrido.cliente_proveedor_rut)
    //     recorrido.tipoDteNombre = this.getNombreTipoDte(recorrido.tipo_dte_codigo)
    //     console.log("**** Documento ***",recorrido.permiteNCAnulacion)
    //     console.log("**** Producto ****", recorrido.permiteNCParcial)
    //   })
    //   this.loading = false


    // })


    this.spinner.show();



    this.recorridoDetalleService.getDevolucionFiltro(inputParams);

    this.recorridoDetalleService.queryCliente.subscribe((data: any[]) => {
      let ok = data[0].obtenerDetalleRecorrido.respuesta !== null
      if (!ok) {
        this.messageRendererService.showWarningMessages(data[0].obtenerDetalleRecorrido.mensajes)
        //this.handleSearchError()
        return
      }
      this.PagPosActual = data[0].obtenerDetalleRecorrido.respuesta.paginaActual
      this.totalPagPos = data[0].obtenerDetalleRecorrido.respuesta.totalPaginas
      this.totalRegistrosPos = data[0].obtenerDetalleRecorrido.respuesta.totalRegistros
      this.listaRecorridos = data[0].obtenerDetalleRecorrido.respuesta.registros.slice(0, 20);
      this.listaRecorridos.map(recorrido => {
        recorrido.rutEmisorFormato = this.rutService.AgregarDV(recorrido.cliente_proveedor_rut)
        recorrido.tipoDteNombre = this.getNombreTipoDte(recorrido.tipo_dte_codigo)
        console.log("**** Documento ***", recorrido.permiteNCAnulacion)
        console.log("**** Producto ****", recorrido.permiteNCParcial)
      })

      this.spinner.hide();
      if (data[0].obtenerDetalleRecorrido.respuesta.paginaActual === data[0].obtenerDetalleRecorrido.respuesta.totalPaginas) {
        self.document.getElementById("spinnerX").style.display = "none";
      }
    })
    this.notscrolly = true;
    this.notEmptyPost = true;
    this.PageNum = 1;
  }

  onPageChange(context: PaginationContext) {
    this.iniciarDevolucion(context.RequestedPage)
  }

  getNombreTipoDte(tipo_dte_codigo: number): string {
    const _listaTiposDte = this.listaTiposDte.filter(tipoDte => tipoDte.codigo === tipo_dte_codigo)
    if (_listaTiposDte && _listaTiposDte.length > 0)
      return _listaTiposDte[0].descripcion
    return ''
  }

}

